<template>
  <div id="app">
    <transition name="router-fade" mode="out-in">
      <router-view />
    </transition>
    <div class="mask_wx" v-if="isWx">
      <img src="./images/mask_wx.png" alt="" />
    </div>
  </div>
</template>

<script>
import { QueryString } from "./js/common";
import { mapMutations } from "vuex";
export default {
  name: "App",
  data() {
    return {
      isWx: false
    };
  },
  mounted() {
    console.log(this);
    console.log("H5改变验证代码");
    let channel = this.getUrl("channel") || "";
    let shq = this.getUrl("shq") || "";
    if (channel.indexOf("zhwk") > -1) {
      console.log("show zhwk");
      localStorage.setItem("zhwk", true);
    }
    if (shq) {
      console.log("shq");
      localStorage.setItem("shq", true);
    }
    this.maskWx();
    const bd_vid = QueryString("bd_vid") || this.getUrl("bd_vid");
    console.log(bd_vid);
    if (bd_vid) {
      sessionStorage.setItem("bd_vid", bd_vid);
    }
    channel && localStorage.setItem("channel", channel);

    const initiatorId = this.getUrl("initiatorId") || "";
    const assistModeType = this.getUrl("assistModeType") || "";
    if (initiatorId) {
      sessionStorage.setItem("initiatorId", initiatorId);
      sessionStorage.setItem("assistModeType", assistModeType);
    }

    // 设置商户上号器appChannel
    let appChannel = this.getUrl("appChannel") || "";
    let appChannel1 = localStorage.getItem("appChannel");
    console.log("appChannel1", appChannel, appChannel1);
    if (appChannel) {
      console.log("1");
      this.setAppChannel(appChannel);
    } else if (appChannel1) {
      console.log("2");
      this.setAppChannel(appChannel1);
    }
  },
  methods: {
    ...mapMutations(["setAppChannel"]),
    getUrl(name) {
      let url = window.location.href;
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = !url.split("?")[1] ? "" : url.split("?")[1].match(reg);
      if (!!r) return decodeURI(r[2]);
      return null;
    },
    maskWx() {
      let ua = navigator.userAgent.toLowerCase();
      let isWeixin = ua.indexOf("micromessenger") != -1;
      if (isWeixin) {
        this.isWx = true;
      }
    }
  }
};
</script>

<style lang="scss">
@import "./style/reset";

// 引入阿里icon
@font-face {
  font-family: "iconfont"; /* project id 252520 */
  src: url("//at.alicdn.com/t/font_252520_bl2ny27ff54.eot");
  src: url("//at.alicdn.com/t/font_252520_bl2ny27ff54.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_252520_bl2ny27ff54.woff") format("woff"),
    url("//at.alicdn.com/t/font_252520_bl2ny27ff54.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_252520_bl2ny27ff54.svg#iconfont") format("svg");
}

#app {
  .mask_wx {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.94);
    overflow: hidden;
    img {
      display: block;
      width: px2rem(750rem);
      height: px2rem(270rem);
      margin: 0.12rem auto;
    }
  }
}

.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.1s;
}
.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue